var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackgroundImageSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 281,
    viewBox: "0 0 310 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.399 24.1833C285.886 17.879 283.545 9.91006 277.17 6.38418C270.795 2.8583 262.801 5.11067 259.314 11.415C255.827 17.7193 258.168 25.6882 264.542 29.2141C270.917 32.74 278.912 30.4876 282.399 24.1833Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3686 271.4C64.0217 266.604 62.2405 260.54 57.3901 257.858C52.5398 255.175 46.457 256.889 43.8039 261.685C41.1508 266.482 42.932 272.546 47.7824 275.228C52.6327 277.911 58.7155 276.197 61.3686 271.4Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0528 31.318C45.5498 26.8034 43.8734 21.0967 39.3083 18.5718C34.7433 16.0468 29.0184 17.6598 26.5213 22.1744C24.0243 26.6891 25.7007 32.3957 30.2657 34.9207C34.8308 37.4456 40.5557 35.8326 43.0528 31.318Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.732 130.119C308.48 126.96 307.307 122.966 304.112 121.199C300.917 119.432 296.911 120.561 295.164 123.72C293.417 126.88 294.59 130.873 297.784 132.64C300.979 134.407 304.985 133.278 306.732 130.119Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0762 189.934C13.5085 187.344 12.5469 184.071 9.92833 182.622C7.30976 181.174 4.02584 182.099 2.59349 184.689C1.16115 187.279 2.12277 190.552 4.74134 192C7.35992 193.449 10.6438 192.523 12.0762 189.934Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.042 236.438C265.114 234.499 264.394 232.048 262.434 230.963C260.473 229.879 258.014 230.572 256.942 232.511C255.869 234.45 256.589 236.901 258.55 237.985C260.511 239.069 262.969 238.377 264.042 236.438Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 259.314,
    y1: 11.415,
    x2: 282.399,
    y2: 24.1833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCBDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#049AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.8039,
    y1: 261.685,
    x2: 61.3686,
    y2: 271.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCBDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#049AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 39.2454,
    y1: 38.2018,
    x2: 28.3754,
    y2: 19.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF410F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 295.164,
    y1: 123.72,
    x2: 306.732,
    y2: 130.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CCC5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2.59349,
    y1: 184.689,
    x2: 12.0762,
    y2: 189.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CCC5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 256.942,
    y1: 232.511,
    x2: 264.042,
    y2: 236.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CCC5A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImageSmall);
export default __webpack_public_path__ + "static/media/background_image_small.c55f96878cd932afb17ba89923bc92da.svg";
export { ForwardRef as ReactComponent };